export default {
  questionnaire_details:'問卷詳情',
  questionnaire_submit_success:"問卷已提交成功",
  questionnaire_bcak_list:'返回問卷列表',
  questionnaire_no:'還沒有問卷',
}
